import React, { useState } from "react";
import "./Header.css";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(null);

  const toggleMobileMenu = (e) => {
    e.preventDefault();
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const toggleSubmenu = (menu) => {
    setActiveSubmenu(activeSubmenu === menu ? null : menu);
  };

  const closeMenu = () => {
    setMobileMenuOpen(false);
    setActiveSubmenu(null);
  };

  return (
    <>
      {/* Top Bar */}
      <div className="kingster-body">
        <div className="kingster-top-bar">
          <div className="kingster-top-bar-background"></div>
          <div className="kingster-top-bar-container kingster-container">
            <div className="kingster-top-bar-container-inner clearfix">
              <div className="kingster-top-bar-left kingster-item-pdlr">
                <i className="fa fa-envelope-open-o"></i> immaculatekkl@gmail.com
                &nbsp;&nbsp;
                <i className="fa fa-phone"></i> 8148037301 / 9791466774
              </div>
              <div className="kingster-top-bar-right kingster-item-pdlr">
                <ul className="kingster-top-bar-menu kingster-top-bar-right-menu">
                  <li className="menu-item">
                    <a href="#">For Admission : 04368 - 236840 / 236830</a>
                  </li>
                </ul>
                <a
                  className="kingster-top-bar-right-button"
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Admissions
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Header */}
      <div className="kingster-mobile-header-wrap">
        <div
          className="kingster-mobile-header kingster-header-background kingster-style-slide kingster-sticky-mobile-navigation"
          id="kingster-mobile-header"
        >
          <div className="kingster-mobile-header-container kingster-container clearfix">
            <div className="kingster-logo kingster-item-pdlr">
              <div className="kingster-logo-inner">
                <a href="/">
                  <img src="/assets/images/logo.png" alt="IIHS Logo" />
                </a>
              </div>
            </div>

            <div className="kingster-mobile-menu-right">
              {/* Search */}
              <div
                className="kingster-main-menu-search"
                id="kingster-mobile-top-search"
              >
                <i className="fa fa-search"></i>
              </div>

              {/* Mobile Menu */}
              <div className="kingster-mobile-menu">
                <a
                  className="kingster-mm-menu-button kingster-mobile-menu-button kingster-mobile-button-hamburger"
                  href="#kingster-mobile-menu"
                  role="button"
                  aria-expanded={mobileMenuOpen}
                  onClick={toggleMobileMenu}
                >
                  <span></span>
                  <span></span>
                  <span></span>
                </a>
                <div
                  className={`kingster-mm-menu-wrap kingster-navigation-font ${
                    mobileMenuOpen ? "active" : ""
                  }`}
                  id="kingster-mobile-menu"
                  data-slide="right"
                >
                  <ul className="m-menu">
                    <li className="menu-item"><a href="/" onClick={closeMenu}>Home</a></li>

                    {/* About Us */}
                    <li className={`menu-item has-submenu ${activeSubmenu === "about" ? "active" : ""}`}>
                      <a href="#" onClick={(e) => { e.preventDefault(); toggleSubmenu("about"); }}>About Us</a>
                      {activeSubmenu === "about" && (
                        <ul className="sub-menu">
                          <li><a href="/about/congregation" onClick={closeMenu}>Congregation</a></li>
                          <li><a href="/about/management" onClick={closeMenu}>Management</a></li>
                          <li><a href="/about/faculty" onClick={closeMenu}>Faculty</a></li>
                          <li><a href="/about/parent-hospital" onClick={closeMenu}>Parent Hospital</a></li>
                          <li><a href="/about/training" onClick={closeMenu}>Students Training Area</a></li>
                          <li><a href="/about/placement" onClick={closeMenu}>Placement</a></li>
                        </ul>
                      )}
                    </li>

                    {/* Courses */}
                    <li className={`menu-item has-submenu ${activeSubmenu === "courses" ? "active" : ""}`}>
                      <a href="#" onClick={(e) => { e.preventDefault(); toggleSubmenu("courses"); }}>Courses</a>
                      {activeSubmenu === "courses" && (
                        <ul className="sub-menu">
                          <li><a href="/courses/bsc-nursing" onClick={closeMenu}>B.Sc. Nursing</a></li>
                          <li><a href="/courses/dgnm" onClick={closeMenu}>DGNM</a></li>
                        </ul>
                      )}
                    </li>

                    {/* facilities */}
                    <li className={`menu-item has-submenu ${activeSubmenu === "facilities" ? "active" : ""}`}>
                      <a href="#" onClick={(e) => { e.preventDefault(); toggleSubmenu("facilities"); }}>Facilities</a>
                      {activeSubmenu === "facilities" && (
                        <ul className="sub-menu">
                          <li><a href="/facilities/labs" onClick={closeMenu}>Labs</a></li>
                          <li><a href="/facilities/academic" onClick={closeMenu}>Academic</a></li>
                          <li><a href="/facilities/hostel" onClick={closeMenu}>Hostel</a></li>
                          <li><a href="/facilities/transport" onClick={closeMenu}>Transport</a></li>
                        </ul>
                      )}
                    </li>

                    {/* Activities */}
                    <li className={`menu-item has-submenu ${activeSubmenu === "activities" ? "active" : ""}`}>
                      <a href="#" onClick={(e) => { e.preventDefault(); toggleSubmenu("activities"); }}>Activities</a>
                      {activeSubmenu === "activities" && (
                        <ul className="sub-menu">
                          <li><a href="/activities/developmental" onClick={closeMenu}>Developmental</a></li>
                          <li><a href="/activities/academical" onClick={closeMenu}>Academical</a></li>
                          <li><a href="/activities/health-education" onClick={closeMenu}>Health Education</a></li>
                        </ul>
                      )}
                    </li>

                    {/* Extracurricular */}
                    <li className={`menu-item has-submenu ${activeSubmenu === "extra" ? "active" : ""}`}>
                      <a href="#" onClick={(e) => { e.preventDefault(); toggleSubmenu("extra"); }}>Extracurricular</a>
                      {activeSubmenu === "extra" && (
                        <ul className="sub-menu">
                          <li><a href="/extracurricular/faculty" onClick={closeMenu}>Faculty</a></li>
                          <li><a href="/extracurricular/students" onClick={closeMenu}>Students</a></li>
                        </ul>
                      )}
                    </li>

                    <li className="menu-item"><a href="/gallery" onClick={closeMenu}>Gallery</a></li>
                    <li className="menu-item"><a href="/contact" onClick={closeMenu}>Contact Us</a></li>
                    <li className="menu-item"><a href="/news-events" onClick={closeMenu}>News and Events</a></li>
                    <li className="menu-item"><a href="/alumni" onClick={closeMenu}>Alumni</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Desktop Header */}
      <header className="kingster-header-wrap kingster-header-style-plain kingster-style-menu-right kingster-sticky-navigation kingster-style-fixed">
        <div className="kingster-header-background"></div>
        <div className="kingster-header-container kingster-container">
          <div className="kingster-header-container-inner clearfix">
            <div className="kingster-logo kingster-item-pdlr">
              <div className="kingster-logo-inner">
                <a href="/">
                  <img src="/assets/images/logo.png" alt="IIHS Logo" />
                </a>
              </div>
            </div>

            <div className="kingster-navigation kingster-item-pdlr clearfix">
              <div className="kingster-main-menu" id="kingster-main-menu">
                <ul className="main-nav">
                  <li className="menu-item"><a href="/">Home</a></li>

                  {/* About Us */}
                  <li className="menu-item has-submenu">
                    <a href="#">About Us</a>
                    <ul className="sub-menu">
                      <li><a href="/about/congregation">Congregation</a></li>
                      <li><a href="/about/management">Management</a></li>
                      <li><a href="/about/faculty">Faculty</a></li>
                      <li><a href="/about/parent-hospital">Parent Hospital</a></li>
                      <li><a href="/about/training">Students Training Area</a></li>
                      <li><a href="/about/placement">Placement</a></li>
                    </ul>
                  </li>

                  {/* Courses */}
                  <li className="menu-item has-submenu">
                    <a href="#">Courses</a>
                    <ul className="sub-menu">
                      <li><a href="/courses/bsc-nursing">B.Sc. Nursing</a></li>
                      <li><a href="/courses/dgnm">DGNM</a></li>
                    </ul>
                  </li>

                  {/* facilities */}
                  <li className="menu-item has-submenu">
                    <a href="#">facilities</a>
                    <ul className="sub-menu">
                      <li><a href="/facilities/labs">Labs</a></li>
                      <li><a href="/facilities/academic">Academic</a></li>
                      <li><a href="/facilities/hostel">Hostel</a></li>
                      <li><a href="/facilities/transport">Transport</a></li>
                    </ul>
                  </li>

                  {/* Activities */}
                  <li className="menu-item has-submenu">
                    <a href="#">Activities</a>
                    <ul className="sub-menu">
                      <li><a href="/activities/developmental">Developmental</a></li>
                      <li><a href="/activities/academical">Academical</a></li>
                      <li><a href="/activities/health-education">Health Education</a></li>
                      <li><a href="/activities/extracurricular">Extracurricular</a></li>
                    </ul>
                  </li>

                 
                  <li className="menu-item"><a href="/gallery">Gallery</a></li>
                  <li className="menu-item"><a href="/contact">Contact Us</a></li>
                  
                 
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
